// utils/api.ts

type HttpMethod = "POST" | "PUT" | "PATCH" | "DELETE";

export async function apiRequest<T>(
  method: HttpMethod,
  url: string,
  data: any = {},
  headers: Record<string, string> = {}
): Promise<T> {
  const isFormData = data instanceof FormData;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URI}${url}`, {
      method,
      headers: {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        ...headers,
      },
      body: isFormData ? data : JSON.stringify(data),
    });

    const contentType = response.headers.get("Content-Type") || "";
    const isJson = contentType.includes("application/json");
    const result = isJson ? await response.json() : await response.text();

    if (!response.ok) {
      const message =
        (isJson && result?.message) ||
        (typeof result === "string" && result) ||
        "حدث خطأ أثناء الاتصال بالخادم"; // "An error occurred while contacting the server"
      throw new Error(message);
    }

    return result as T;
  } catch (error: any) {
    console.error(`[${method}] ${url} failed:`, error.message);
    throw error; // Rethrow so the UI can display it (e.g. toast or form error)
  }
}

// Shortcuts
export const apiPost = <T>(
  url: string,
  data?: any,
  headers?: Record<string, string>
) => apiRequest<T>("POST", url, data, headers);

export const apiPut = <T>(
  url: string,
  data?: any,
  headers?: Record<string, string>
) => apiRequest<T>("PUT", url, data, headers);

export const apiPatch = <T>(
  url: string,
  data?: any,
  headers?: Record<string, string>
) => apiRequest<T>("PATCH", url, data, headers);

export const apiDelete = <T>(url: string, headers?: Record<string, string>) =>
  apiRequest<T>("DELETE", url, undefined, headers);
